export const MINUTE_IN_MS = 60 * 1000;
export const DAY_IN_MS = 24 * 60 * MINUTE_IN_MS;

// n days - 1 min
export const COOKIE_EXPIRY_CART_TYPE_ANONYMOUS = 365 * DAY_IN_MS - MINUTE_IN_MS;
export const COOKIE_EXPIRY_CART_TYPE_CUSTOMER = 10 * DAY_IN_MS - MINUTE_IN_MS;

export enum CartType {
  Anonymous = "A",
  Customer = "C",
}

export enum CheckoutCookie {
  CartId = "chk_cart_id",
  CartType = "chk_cart_typ",
}

// The constants and configurations defined above serve as the source of truth for this system.

export enum SecondaryCookie {
  TagularAnonymousSession = "tglr_anon_id",
}

export const ModifyingHTTPMethods = ["POST", "PUT", "DELETE", "PATCH"];
